import React from "react";
import {Modal, Typography} from "antd";

const { Text } = Typography;


export const BankProcessModal: React.FC<{
    open: boolean;
    onClose: () => void;
    processDefinition?: string;
    amount?: string;
    paymentReference?: string;
}> = ({ open, onClose, processDefinition, amount, paymentReference }) => {
    const bankProcess = processDefinition ? JSON.parse(processDefinition) : null;

    return (
        <Modal
            title="Bank Payment Instructions"
            open={open}
            onOk={onClose}
            cancelButtonProps={{ style: { display: 'none' } }}
            okText="Proceed to Complete Registration"
        >
            <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-md">
                    <Text strong>Payment Details:</Text>
                    <div className="mt-2">
                        <Text>Amount: {amount} TZS</Text>
                        <br />
                        <Text>Reference: {paymentReference}</Text>
                    </div>
                </div>

                {bankProcess && (
                    <>
                        <div className="space-y-4 mt-4">
                            {bankProcess.steps.map((step: any, index: number) => (
                                <div key={index} className="border-b pb-4">
                                    <Text strong>{`${index + 1}. ${step.instruction}`}</Text>
                                    <Text className="block mt-1 text-gray-600">
                                        {step.description}
                                    </Text>
                                </div>
                            ))}
                        </div>

                        {bankProcess.additionalInfo && (
                            <div className="bg-gray-50 p-4 rounded-md mt-4">
                                <Text strong>Additional Information:</Text>
                                <div className="mt-2">
                                    <Text>Support: {bankProcess.additionalInfo.supportContact}</Text>
                                    <br />
                                    <Text>{bankProcess.additionalInfo.notes}</Text>
                                </div>
                            </div>
                        )}
                    </>
                )}

                <div className="bg-yellow-50 p-4 rounded-md mt-4">
                    <Text type="warning">
                        Note: Your account details will be sent to your email and phone number once payment is confirmed.
                    </Text>
                </div>
            </div>
        </Modal>
    );
};